const translations = {
  addHours: {
    subtitle: "Looks like you're out of hours. Go to your account to extend your Grayce services.",
    title: "Want to add another journey?"
  }
};

export default translations;
